import { Button, Input } from 'components/forms';
import { Field, FormikProvider, useFormik } from 'formik';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from 'store/auth/actions';
import { API_ENDPOINTS, request } from 'utilities';
import notification from 'utilities/notification';

const UserLoginForm = () => {
    const [email, setEmail] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const dispatch = useDispatch();

    const emailForm = useFormik({
        initialValues: {
            email: '',
        },
        onSubmit: async (values) => {
            try {
                const response = await request.post(API_ENDPOINTS.AUTH.REGISTER, values);
                notification('success', response?.message || 'OTP sent successfully');
                setEmail(values.email);
                setIsOtpSent(true);
            } catch (error) {
                notification('error', error?.message || 'Failed to send OTP');
            }
        },
    });

    const otpForm = useFormik({
        initialValues: {
            otp: '',
        },
        onSubmit: async (values) => {
            try {
                const payload = { email, otp: values.otp };
                const response = await dispatch(login(API_ENDPOINTS.AUTH.LOGIN, payload));
                notification('success', response?.message || 'Login successful');
            } catch (error) {
                notification('error', error?.message || 'Login failed');
            }
        },
    });

    return (
        <Fragment>
            {!isOtpSent ? (
                <FormikProvider value={emailForm}>
                    <form className="checkout-form" onSubmit={emailForm.handleSubmit}>
                        <Field
                            label="Email"
                            type="email"
                            name="email"
                            icon={() => <i className="name-icon" />}
                            variant="2"
                            component={Input}
                        />
                        <Button type="submit" className="btn btn-dark" label="Send OTP" />
                    </form>
                </FormikProvider>
            ) : (
                <FormikProvider value={otpForm}>
                    <form className="checkout-form" onSubmit={otpForm.handleSubmit}>
                        <Field
                            label="Enter OTP"
                            type="text"
                            name="otp"
                            icon={() => <i className="name-icon" />}
                            variant="2"
                            component={Input}
                        />
                        <Button type="submit" className="btn btn-dark" label="Login Now" />
                    </form>
                </FormikProvider>
            )}
        </Fragment>
    );
};

export default UserLoginForm;
